import { QuestionType } from "api/landlord-surveys/types/questions";
import { DraftSurveyTemplateQuestion } from "../../types";
import {
  YesNoPreview,
  RadioPreview,
  MultiselectPreview,
  LongTextPreview,
  DatePreview,
  FilePreview,
  AddressPreview
} from "shared/app/land-x/widgets";

export const QuestionInput = ({
  question,
  answer,
  onAnswer
}: {
  question: DraftSurveyTemplateQuestion;
  answer: string | string[] | undefined;
  onAnswer: (value: string | string[]) => void;
}) => {
  switch (question.type) {
    case QuestionType.YES_NO:
      return (
        <YesNoPreview
          options={question.options}
          selected={typeof answer === "string" ? answer : ""}
          onSelect={onAnswer}
        />
      );
    case QuestionType.RADIO_GROUP:
      return (
        <RadioPreview
          options={question.options}
          selected={typeof answer === "string" ? answer : ""}
          onSelect={onAnswer}
        />
      );
    case QuestionType.CHECKBOX_MULTI:
      return (
        <MultiselectPreview
          options={question.options}
          selected={Array.isArray(answer) ? answer : []}
          onToggle={(opt) => {
            const sel = Array.isArray(answer) ? answer : [];
            const next = sel.includes(opt)
              ? sel.filter((s) => s !== opt)
              : [...sel, opt];
            onAnswer(next);
          }}
        />
      );
    case QuestionType.LONG_TEXT:
      return (
        <LongTextPreview
          value={typeof answer === "string" ? answer : ""}
          onChange={onAnswer}
        />
      );
    case QuestionType.DATE:
      return (
        <DatePreview
          value={typeof answer === "string" ? answer : ""}
          onChange={onAnswer}
        />
      );
    case QuestionType.FILE_SINGLE:
      return <FilePreview onSelect={onAnswer} />;
    case QuestionType.ADDRESS:
      return (
        <AddressPreview
          value={typeof answer === "string" ? answer : ""}
          onChange={onAnswer}
        />
      );
    default:
      return null;
  }
};
